import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface NavBarProps {
    mark: number;
    onChange: (val: number) => void;
}

export default function NavBar({ mark, onChange }: NavBarProps) {
    return (
        <div className={style.root}>
            <div className={style.links}>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 1
                    })}
                    onClick={() => onChange(1)}>
                    三分屏回放
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 2
                    })}
                    onClick={() => onChange(2)}>
                    屏幕共享回放
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 3
                    })}
                    onClick={() => onChange(3)}>
                    直播统计
                </div>
            </div>
        </div>
    );
}
